"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
var React = require("react");
var Modal = require("react-modal");
var mobx_react_1 = require("mobx-react");
var typestyle_1 = require("typestyle");
var DialogHeader = (function (_super) {
    __extends(DialogHeader, _super);
    function DialogHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogHeader.prototype.render = function () {
        var props = this.props;
        return (React.createElement("div", { className: (0, typestyle_1.classes)("Dialog__Header", props.className) },
            React.createElement("div", { className: "Dialog__HeaderWrapper" },
                React.createElement("span", null, props.title)),
            React.createElement(CloseTicker, { onClick: props.onTickerClick })));
    };
    return DialogHeader;
}(React.Component));
var DialogBody = (function (_super) {
    __extends(DialogBody, _super);
    function DialogBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogBody.prototype.render = function () {
        return (React.createElement("div", { className: "Dialog__Body" }, this.props.children));
    };
    return DialogBody;
}(React.Component));
var CloseTicker = (function (_super) {
    __extends(CloseTicker, _super);
    function CloseTicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CloseTicker.prototype.render = function () {
        var props = this.props;
        return (React.createElement("a", { href: "#0", className: "Dialog__CloseTicker", onClick: props.onClick },
            React.createElement("i", { className: "fas fa-fw fa-times" }, " ")));
    };
    return CloseTicker;
}(React.Component));
var Dialog = (function (_super) {
    __extends(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        if (props.onClose) {
            window.addEventListener("keyup", _this.closeOnEscape.bind(_this));
        }
        return _this;
    }
    Dialog.prototype.closeOnEscape = function (e) {
        if (e.keyCode == 27) {
            this.props.onClose();
        }
    };
    Dialog.prototype.componentWillUnmount = function () {
        if (this.props.onClose) {
            window.removeEventListener("keyup", this.closeOnEscape.bind(this));
        }
    };
    Dialog.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var isReady = this.props.isReady === undefined ? true : this.props.isReady;
        return (React.createElement(Modal, { isOpen: props.isOpen, contentLabel: props.contentLabel, shouldCloseOnOverlayClick: props.shouldCloseOnOverlayClick, className: "Dialog", overlayClassName: "Dialog__Overlay", onAfterOpen: props.onAfterOpen },
            React.createElement("div", { ref: function (div) {
                    var target = $(div).parent();
                    target.draggable({ handle: ".Dialog__DragHandle" });
                    _this.props.forcedWidth && target.width(_this.props.forcedWidth);
                } }, isReady ?
                React.createElement("div", null,
                    React.createElement(DialogHeader, { title: props.contentLabel, onTickerClick: props.onClose, className: "Dialog__DragHandle" }),
                    React.createElement(DialogBody, null, props.children))
                :
                    React.createElement("div", null,
                        React.createElement(DialogHeader, { title: "Loading...", onTickerClick: props.onClose, className: "Dialog__DragHandle" }),
                        React.createElement(DialogBody, null)))));
    };
    Dialog = __decorate([
        mobx_react_1.observer
    ], Dialog);
    return Dialog;
}(React.Component));
exports.Dialog = Dialog;
